/** @format */

import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import galaxieClient from "@/api/galaxieClient";
import type { RunDetail } from "@/lib/schemas/apiSchemas";
import { lazyWithRetry } from "@/utils/lazyWithRetry";
import PageLoader from "@/utils/PageLoader";
import { RouteErrorComponent } from "@/utils/RouteErrorComponent";

const LivePage = lazyWithRetry(() => import("@/pages/Live"));

export const Route = createFileRoute("/live")({
  // Loader to pre-fetch live runs and previous races
  loader: async ({ context }) => {
    // Pre-fetch live runs and previous races in parallel
    await Promise.all([
      context.queryClient.prefetchQuery({
        queryKey: ["liveRuns"],
        queryFn: async () => {
          const response = await galaxieClient.get("/live/");
          return {
            data: response.data as RunDetail[],
            version: response.headers["x-version"] as string,
          };
        },
        staleTime: 20 * 1000, // 20 seconds for live data
      }),
      context.queryClient.prefetchQuery({
        queryKey: ["previous_race"],
        queryFn: async () => {
          const response = await galaxieClient.get("/previous_race/");
          return response.data as unknown[];
        },
        staleTime: 5 * 60 * 1000, // 5 minutes
      }),
    ]);
  },
  component: () => (
    <Suspense fallback={<PageLoader />}>
      <LivePage />
    </Suspense>
  ),
  errorComponent: RouteErrorComponent,
});
